import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ContainerModel } from '@app/models/server/layout.model';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
// import { LoggerService } from '@app/services/util-services/logger.service';
import { Location, NgClass, NgOptimizedImage } from '@angular/common';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { delay, of, Subscription } from 'rxjs';
import { MenuKeyCheckerPipe } from '@app/components/pipes/menu-key-checker.pipe';
import { FEATURE_TYPES } from '@app/constants/app-settings';
import { TapEffect } from '@app/components/directives/tap-effect.ts/tap-effect';

@Component({
  selector: 'lib-b2b-menu-card',
  templateUrl: './b2b-menu-card.component.html',
  styleUrls: ['./b2b-menu-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    MenuKeyCheckerPipe,
    TapEffect,
    NgOptimizedImage,
  ],
})
export class B2bMenuCardComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('menuItemsContainer')
  menuItemsContainer: ElementRef;

  @Input() containers: ContainerModel[] = [];

  // tempContainers: ContainerModel[] = [];

  @Input() skeletonTabs: Array<number> = new Array<number>(8);

  selectedContainer: ContainerModel;

  page: number = Number(1);
  totalPages: number = Number(1);

  selectMenuCategorySubscription$: Subscription;

  featureTypes = FEATURE_TYPES;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public location: Location,
    private eventService: EventService,
  ) {
    // LoggerService.log('route is ', route);
    // LoggerService.log('location is ', location);
    // LoggerService.warn('menu card constructor is called');
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.warn('Inside menu card changes ', changes);
    if (changes?.containers?.currentValue) {
      this.checkInitialRoute();
      this.setTotalPages(this.containers?.length);
    }
  }

  ngOnInit() {}

  scrollLeft() {
    this.menuItemsContainer.nativeElement.scrollLeft =
      this.menuItemsContainer.nativeElement.offsetWidth * this.page;
    this.page++;
  }

  scrollRight() {
    this.page--;
    if (this.page === 1) {
      this.menuItemsContainer.nativeElement.scrollLeft = 0;
    } else {
      this.menuItemsContainer.nativeElement.scrollLeft =
        this.menuItemsContainer.nativeElement.offsetWidth *
        (this.totalPages - this.page);
    }
  }

  setTotalPages(itemsLength: number) {
    this.totalPages = Math.ceil(itemsLength / 8);
  }

  checkInitialRoute() {
    for (const container of this.containers) {
      if (
        container?.activeUrls?.indexOf(this.router?.url?.split('?')[0]) > -1
      ) {
        this.onSelectTab(container);
      }
    }
  }

  gotoExtendedStay() {
    this.router.navigateByUrl('/hotels-stay').then();
  }

  onSelectTab(container: ContainerModel): void {
    if (container?.isActive) {
      this.selectedContainer = container;
      this.publishSelectMenuCategoryEvent(this.selectedContainer);
    }
  }

  publishSelectMenuCategoryEvent(container: ContainerModel) {
    this.selectMenuCategorySubscription$ = of(container)
      .pipe(delay(500))
      .subscribe({
        next: (result: ContainerModel) => {
          this.eventService.selectMenuCategoryEvent.emit({
            selectedTab: result?.category,
          });
        },
      });
  }

  ngOnDestroy(): void {
    if (this.selectMenuCategorySubscription$) {
      this.selectMenuCategorySubscription$.unsubscribe();
    }
  }

  ionViewDidLeave() {
    if (this.selectMenuCategorySubscription$) {
      this.selectMenuCategorySubscription$.unsubscribe();
    }
  }
}
